// extracted by mini-css-extract-plugin
export default {"selectLabel":"SelectLabel_selectLabel__K3LpX"};